export default "__VITE_ASSET__5ff5953b__"